<div class="form-container">
  <!-- Busca de assinante -->
  <section class="search-section">
    <h4>Buscar Assinante</h4>
    <form [formGroup]="searchForm" (ngSubmit)="search()" class="search-form">
      <div class="search-fields">
        <span class="p-float-label">
          <p-inputNumber
            inputId="personId"
            formControlName="personId"
            [useGrouping]="false"
          />
          <label for="personId">PersonId</label>
        </span>
        <span class="p-float-label">
          <p-inputNumber
            inputId="subscriberId"
            formControlName="subscriberId"
            [useGrouping]="false"
          />
          <label for="subscriberId">SubscriberId</label>
        </span>
        <span class="p-float-label">
          <input pInputText id="email" formControlName="email" type="email" />
          <label for="email">E-mail</label>
        </span>
        <span class="p-float-label">
          <input pInputText id="boxId" formControlName="boxId" />
          <label for="boxId">BoxId</label>
        </span>
      </div>
      <p-button
        label="Buscar"
        type="submit"
        [disabled]="
          !searchForm.value.personId &&
          !searchForm.value.subscriberId &&
          !searchForm.value.email &&
          !searchForm.value.boxId
        "
      />
    </form>

    <!-- Resultados da busca -->
    <ng-container *ngIf="searched">
      <ng-container *ngIf="subscribers.length > 0; else noResults">
        <p-table
          [value]="subscribers"
          styleClass="p-datatable-sm p-datatable-striped"
          [scrollable]="true"
          scrollHeight="200px"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>PersonId</th>
              <th>SubscriberId</th>
              <th>Nome</th>
              <th>Assinatura</th>
              <th>Status</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-subscriber>
            <tr
              [class.selected-row]="
                selectedSubscriber?.subscriberId === subscriber.subscriberId
              "
            >
              <td>{{ subscriber.personId }}</td>
              <td>{{ subscriber.subscriberId }}</td>
              <td>{{ subscriber.shippingName }}</td>
              <td>{{ subscriber.subscriptionName }}</td>
              <td>{{ subscriber.status }}</td>
              <td>
                <p-button
                  *ngIf="
                    selectedSubscriber?.subscriberId !== subscriber.subscriberId
                  "
                  label="Selecionar"
                  severity="secondary"
                  size="small"
                  (onClick)="selectSubscriber(subscriber)"
                />
                <p-button
                  *ngIf="
                    selectedSubscriber?.subscriberId === subscriber.subscriberId
                  "
                  label="Selecionado"
                  severity="success"
                  size="small"
                  [disabled]="true"
                />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>
      <ng-template #noResults>
        <p class="no-results">Nenhum assinante encontrado.</p>
      </ng-template>
    </ng-container>
  </section>

  <!-- Formulário de cadastro -->
  <form [formGroup]="form" (ngSubmit)="submit()" class="register-form">
    <div class="selected-subscriber" *ngIf="selectedSubscriber">
      <span>
        <strong>Assinante selecionado:</strong>
        {{ selectedSubscriber.shippingName }} — Person ID:
        {{ selectedSubscriber.personId }}
      </span>
      <p-button
        icon="pi pi-times"
        severity="danger"
        [rounded]="true"
        [text]="true"
        size="small"
        type="button"
        (onClick)="clearSubscriber()"
        pTooltip="Remover seleção"
        tooltipPosition="top"
      />
    </div>

    <span class="p-float-label">
      <p-dropdown
        appendTo="body"
        inputId="shippingCompanyId"
        [options]="shippingCompanies"
        optionLabel="shippingCompanyName"
        optionValue="shippingCompanyId"
        formControlName="shippingCompanyId"
        [filter]="true"
        filterBy="shippingCompanyName"
        [autoDisplayFirst]="false"
        styleClass="p-inputwrapper p-inputwrapper-filled"
        [showClear]="true"
      >
        <ng-template pTemplate="selectedItem" let-company>
          {{ company.shippingCompanyId }} - {{ company.shippingCompanyName }}
        </ng-template>
        <ng-template pTemplate="item" let-company>
          {{ company.shippingCompanyId }} - {{ company.shippingCompanyName }}
        </ng-template>
      </p-dropdown>
      <label for="shippingCompanyId">Transportadora</label>
    </span>

    <span class="p-float-label">
      <textarea
        pInputTextarea
        id="reason"
        formControlName="reason"
        rows="3"
        [autoResize]="true"
      ></textarea>
      <label for="reason">Motivo / Observação</label>
    </span>

    <div class="buttons">
      <p-button
        label="Cancelar"
        severity="danger"
        type="button"
        (onClick)="ref.close()"
      />
      <p-button
        label="Cadastrar"
        severity="primary"
        type="submit"
        [disabled]="!form.valid"
      />
    </div>
  </form>
</div>
